module.exports = __webpack_public_path__ + "static/media/gm.5b82dd99.svg";